(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cta-icon-grid"] && !Shopify.designMode) return;
  try {
    
  // Drag to scroll for scrollable rows
  document.addEventListener('DOMContentLoaded', function () {
    const scrollContainers = document.querySelectorAll('.cta-icon-grid__scroll-row, .cta-icon-grid__container');

    scrollContainers.forEach(function (container) {
      let isDown = false;
      let startX;
      let scrollLeft;

      container.addEventListener('mousedown', function (e) {
        // Only enable drag if container is scrollable (has overflow)
        if (container.scrollWidth <= container.clientWidth) return;
        isDown = true;
        container.style.cursor = 'grabbing';
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
      });

      container.addEventListener('mouseleave', function () {
        isDown = false;
        if (container.scrollWidth > container.clientWidth) {
          container.style.cursor = 'grab';
        }
      });

      container.addEventListener('mouseup', function () {
        isDown = false;
        if (container.scrollWidth > container.clientWidth) {
          container.style.cursor = 'grab';
        }
      });

      container.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 2;
        container.scrollLeft = scrollLeft - walk;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // The Ken Burns zoom is a CSS keyframe animation that plays from scale(1)
    // on its own — the first slide ships server-rendered with .is-active, so
    // it animates from the start state on first paint with no JS re-seed.
    function initSlideshow(root) {
      var slides = root.querySelectorAll('.hh-home-hero__slide');

      if (slides.length <= 1) return;

      var interval = Number.parseInt(root.dataset.slideInterval, 10) || 5000;

      if (root.__hhSlideshowCleanup) root.__hhSlideshowCleanup();

      var current = 0;
      var timer = globalThis.setInterval(function () {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, interval);

      root.__hhSlideshowCleanup = function () {
        globalThis.clearInterval(timer);
        root.__hhSlideshowCleanup = null;
      };
    }

    function initIn(scope) {
      var root = (scope || globalThis.document).querySelector('[data-hh-slideshow]');
      if (root) initSlideshow(root);
    }

    if (globalThis.document.readyState === 'loading') {
      globalThis.document.addEventListener('DOMContentLoaded', function () {
        initIn();
      });
    } else {
      initIn();
    }

    globalThis.document.addEventListener('shopify:section:load', function (e) {
      initIn(e.target);
    });
    globalThis.document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[data-hh-slideshow]');
      if (root && root.__hhSlideshowCleanup) root.__hhSlideshowCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
